module.exports = __webpack_public_path__ + "img/inter13.0bbdbf8a.jpg";